import { observable, makeObservable, flow, computed, action } from "mobx";
import type { FormInstance } from "rc-field-form";
import { live } from "../../services/auth";
import { ELoginType } from "../../objects/user/types";
import user from "../../objects/user/model";
import { SmsCode } from "../../objects/smsCode/model";

export class VM {
  // loginForm?: FormInstance;
  // resetPasswordForm?: FormInstance;
  @observable.ref user = user;

  @observable loginType: ELoginType = ELoginType.sms_code;

  @observable agree: boolean = false;

  liveInterval: NodeJS.Timeout | null;

  @observable smsCode: SmsCode = new SmsCode();

  public constructor() {
    makeObservable(this);
    // console.log("this.user.isLogin", this.user.isLogin);
    // this.init();
    this.liveInterval = null;
  }

  @computed
  get isLogin(): boolean {
    return this.user.isLogin;
  }

  @action
  setLoginType(v: ELoginType) {
    this.loginType = v;
  }

  @flow
  public *init(): Generator<any, any, unknown> {
    if (this.isLogin) {
      this.startLive();
      yield this.user.getUserInfo();
    }
  }

  public startLive() {
    live();
    this.liveInterval = setInterval(() => {
      if (!document.hidden) live();
    }, 60 * 1000);
  }

  // @flow
  // public *loginByGoogle() {
  //   yield this.user.googleLogin();
  //   yield this.user.getUserInfo();
  //   this.startLive();
  // }

  // @flow
  // public *loginByApple() {
  //   yield this.user.appleLogin();
  //   yield this.user.getUserInfo();
  //   this.startLive();
  // }

  @flow
  public *loginByEmail(params: { email: string; email_code: string }) {
    yield this.user.loginByEmail(params);
    yield this.user.getUserInfo();
    this.startLive();
  }

  @flow
  public *loginByMobil(params: {
    mobile: string;
    sms_code?: string;
    password?: string;
  }) {
    yield this.user.loginByMobil(params);
    yield Promise.all([
      this.user.getUserInfo(),
      this.user.getWaterMark(),
      this.startLive(),
    ]);
  }

  @flow
  public *getVerifyCode(mobile: string): Generator<void> {
    yield this.smsCode.sendSmsCode(mobile);
  }

  // @flow
  // public *unbindGoogle({
  //   id,
  //   onSuccess,
  //   onFailure,
  // }: {
  //   id: string;
  //   onSuccess: () => void;
  //   onFailure: () => void;
  // }) {
  //   yield this.user.unbindThirdParty({
  //     platform: "google",
  //     id,
  //     onSuccess,
  //     onFailure,
  //   });
  // }

  // @flow
  // public *unbindApple({
  //   id,
  //   onSuccess,
  //   onFailure,
  // }: {
  //   id: string;
  //   onSuccess: () => void;
  //   onFailure: () => void;
  // }) {
  //   yield this.user.unbindThirdParty({
  //     platform: "apple",
  //     id,
  //     onSuccess,
  //     onFailure,
  //   });
  // }

  // @flow
  // public *bindGoogle(onSuccess: () => void, onFailure: () => void) {
  //   yield this.user.bindThirdParty("google", onSuccess, onFailure);
  // }

  // @flow
  // public *bindApple(onSuccess: () => void, onFailure: () => void) {
  //   yield this.user.bindThirdParty("apple", onSuccess, onFailure);
  // }

  @flow
  public *bindMobile(params: { mobile: string; sms_code: string }) {
    yield this.user.bindMobile(params);
  }

  @flow
  public *unbindMobile(params: { mobile: string; sms_code: string }) {
    yield this.user.unbindMobile(params);
  }

  @flow
  public *bindEmail(params: { email: string; code: string }) {
    yield this.user.bindEmail(params);
  }

  @flow
  public *unbindEmail(params: { email: string; code: string }) {
    yield this.user.unbindEmail(params);
  }

  @flow.bound
  public *logout() {
    clearInterval(this.liveInterval as NodeJS.Timeout);
    yield this.user.logout();
    this.user.setVideoWhitelistStatus(null);
  }

  @flow.bound
  public *logoff() {
    clearInterval(this.liveInterval as NodeJS.Timeout);
    yield this.user.logoff();
  }

  @flow.bound
  public *resetPassword(params: {
    mobile: string;
    sms_code: string;
    password: string;
    confirm: string;
  }) {
    yield this.user.resetPassword(params);
  }

  @flow.bound
  public *initPassword(params: { password: string; confirm: string }) {
    yield this.user.initPassword(params);
    this.user.setNeedInitPasswd(false);
  }

  @flow.bound
  public *editPassword(params: { origin: string; password: string }) {
    yield this.user.editPassword(params);
  }
}

export default new VM();
